var React = require('react');

function Bill248px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M35.963 13.171c.003.03.018.055.018.085v31.682a3 3 0 0 1-2.999 2.996H2.998a3 3 0 0 1-2.999-2.996V3.005A3 3 0 0 1 2.998.01h19.625c.088 0 .166.028.248.05.299-.036.603.022.823.242l11.885 11.872a.998.998 0 0 1 .421.816c0 .064-.025.12-.037.181zM23.987 3.418v8.573h8.581l-8.581-8.573zm9.995 10.57H22.987a.998.998 0 0 1-.999-.998V2.007H2.998a1 1 0 0 0-1 .998v41.933a1 1 0 0 0 1 .999h29.984a1 1 0 0 0 1-.999v-30.95zM28.984 37.95h-2.998a.999.999 0 1 1 0-1.997h2.998a.999.999 0 1 1 0 1.997zm0-5.991h-2.998a.998.998 0 1 1 0-1.996h2.998a.998.998 0 1 1 0 1.996zm0-5.99h-2.998a.999.999 0 1 1 0-1.997h2.998a.999.999 0 1 1 0 1.997zM20.988 37.95H6.995a.998.998 0 1 1 0-1.997h13.993a.999.999 0 1 1 0 1.997zm0-5.991H6.995a.998.998 0 1 1 0-1.996h13.993a.998.998 0 1 1 0 1.996zm0-5.99H6.995a.998.998 0 1 1 0-1.997h13.993a.999.999 0 1 1 0 1.997z","key":1})]);
}

Bill248px.displayName = "Bill248px";

Bill248px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 36 47.94"};

module.exports = Bill248px;

Bill248px.default = Bill248px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/bill-2-48px.svg
// module id = 1128
// module chunks = 0